// Simple logging function for global error logging
export const logError = (error) => {
  // If error is for cancelled request, do not log to console
  if (error.message === 'canceled') return

  console.error(error)
}
